import React from 'react';
const HelpbotLink = ({ children, href }) => {
    return (React.createElement("a", { href: href, target: '_blank', rel: 'noopener noreferrer' }, children));
};
export { HelpbotLink };
